// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-list-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(170px,1fr));grid-gap:15px;grid-template-areas:\"double-poster double-poster\"}@media(max-width:1050px){.title-list-grid{padding-left:15px;padding-right:15px}}@media(max-width:767px){.title-list-grid{grid-template-columns:repeat(auto-fill,minmax(160px,1fr))}}@media(max-width:380px){.title-list-grid{grid-template-columns:repeat(auto-fill,minmax(136px,1fr));grid-gap:10px}}", ""]);
// Exports
module.exports = exports;
